import { render } from "./PikadayWrapper.vue?vue&type=template&id=6c0a21e5&scoped=true"
import script from "./PikadayWrapper.vue?vue&type=script&lang=js"
export * from "./PikadayWrapper.vue?vue&type=script&lang=js"

import "./PikadayWrapper.vue?vue&type=style&index=0&id=6c0a21e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0a21e5"]])

export default __exports__